import { useContext } from 'react';
import ThemeContext from '../context/ThemeContext';

const sizeClasses = {
  xs: 'h-6',
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
  xl: 'h-16',
  '2xl': 'h-24',
};

const assetMap = {
  full: {
    light: '/logo-full-light.svg',
    dark: '/logo-full-dark.svg',
    alt: 'GABHAN ERP',
  },
  mini: {
    light: '/logo-mini-light.svg',
    dark: '/logo-mini-dark.svg',
    alt: 'GABHAN ERP',
  },
  icon: {
    light: '/logo-mini-light.svg',
    dark: '/logo-mini-dark.svg',
    alt: 'GABHAN ERP',
  },
  app: {
    light: '/app-icon.svg',
    dark: '/app-icon-dark.svg',
    alt: 'GABHAN ERP App Icon',
  },
  favicon: {
    light: '/favicon.svg',
    dark: '/favicon.svg',
    alt: 'GABHAN ERP Favicon',
  },
};

const Logo = ({
  size = 'md',
  variant = 'full',
  mode = 'auto',
  className = '',
}) => {
  // Use the app ThemeContext so the logo reacts to in-app theme toggles,
  // not just OS preference. Falls back to OS if rendered outside the provider.
  const themeCtx = useContext(ThemeContext);
  const isDark = mode === 'dark'
    || (mode === 'auto' && (themeCtx?.isDark ?? window.matchMedia('(prefers-color-scheme: dark)').matches));

  const asset = assetMap[variant] || assetMap.full;
  const source = isDark ? asset.dark : asset.light;

  if (variant === 'full') {
    return (
      <img
        src={source}
        alt={asset.alt}
        className={`w-auto ${sizeClasses[size] || sizeClasses.md} ${className}`.trim()}
        draggable="false"
      />
    );
  }

  return (
    <img
      src={source}
      alt={asset.alt}
      className={`w-auto ${sizeClasses[size] || sizeClasses.md} ${className}`.trim()}
      draggable="false"
    />
  );
};

export default Logo;
